import { Injectable } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validator,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  FormatType,
  SummaryModel,
} from "../../components/summary/model/summary.model";
import { FormObjectUtil } from "./model/form-service.model";
@Injectable({
  providedIn: "root",
})
export class FormService {
  constructor(private formBuilder: UntypedFormBuilder) { }

  arrayToFormGroup(objToConvert, typeForForm, readOnly = false): any {
    const array = [];
    const formgroup = new UntypedFormGroup({});
    Object.keys(objToConvert).forEach((controlName) => {
      const control: any = {};
      control.formatType = typeForForm;
      control.techname = controlName;
      control.value = objToConvert[controlName];
      control.label = controlName;
      formgroup.addControl(
        controlName,
        new UntypedFormControl({ value: objToConvert[controlName], disabled: readOnly }, Validators.required)
      );
      array.push(control);
    });
    return { form: formgroup, array };
  }

  summaryListToFormGroup(summaryList: Array<SummaryModel>, globalValidator?): FormObjectUtil {
    console.log('globalvalidator', globalValidator)
    const array = [];
    const formgroup = new UntypedFormGroup({});
    if(globalValidator) {
      formgroup.setValidators(globalValidator());
    }
    summaryList.forEach((summary) => {
      const control: any = {};
      control.formatType = summary.formatType;
      control.techname = summary.techname;
      control.value = summary.value;
      control.label = summary.label;
      control.tooltip = summary.tooltip;
      control.select = summary.select;
      control.widthColumn = summary.widthColumn;
      control.mimeTypeAccepted = summary.mimeTypeAccepted;
      control.disabled = summary.readOnly;
      control.source = summary.source;

      if(summary.formatType === FormatType.text_webform_with_tooltip) {
        control.tooltipContent = summary.tooltipContent
      }
      
      if(!!summary.child){
        control.child = summary.child;
      }
      if (summary.formatType === FormatType.file_webform) {
        control.fileList = summary.value
      }
      if (summary.formatType === FormatType.file) {
        formgroup.addControl(summary.techname, this.formBuilder.array([]));
      } else {
        formgroup.addControl(
          summary.techname,
          new UntypedFormControl(summary.value, summary.validators),
        );
        if (summary.readOnly){
          formgroup.controls[summary.techname].disable();
        }
      }
      array.push(control);
    });
    return { form: formgroup, array };
  }

  toFormGroup(arrayCreateSchema: any): UntypedFormGroup {
    const formgroup = new UntypedFormGroup({});
    if (!!arrayCreateSchema && arrayCreateSchema.length > 0) {
      arrayCreateSchema.forEach((section) => {
        this.addFieldsToForm(section, formgroup);
      });
      return formgroup;
    }
  }

  toFormGroupGeneral(arrayCreateSchema: any, typeForForm, readOnly = false): FormObjectUtil {
    const formgroup = new UntypedFormGroup({});
    const array = [];
    if (!!arrayCreateSchema && arrayCreateSchema.length > 0) {
      arrayCreateSchema.forEach((objToConvert) => {
        const tilesRetrieved = this.arrayToFormGroup(objToConvert, typeForForm, readOnly);
        array.push(tilesRetrieved.array);
      });
      return { form: formgroup, array };
    }
  }

  private addFieldsToForm(section: any, formgroup: UntypedFormGroup) {

    if (!!section.child && section.child.length > 0) {
      const mainSubForm = this.formBuilder.group({});
      formgroup.addControl(section.techname, mainSubForm);
      section.child.forEach((subField) => {
        if (subField.child && subField.child.length > 0) {
          this.addFieldsToForm(subField, mainSubForm);
        } else {
          mainSubForm.addControl(
            subField.techname,
            new UntypedFormControl(subField.value, this.getValidators(subField))
          );
        }
      });
    } else {
      formgroup.addControl(
        section.techname,
        new UntypedFormControl(section.value, this.getValidators(section))
      );
    }
  }

  private getValidators(jsonFilterDefinition): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (jsonFilterDefinition.isMandatory) {
      validators.push(Validators.required);
    }
    if (jsonFilterDefinition.pattern) {
      validators.push(Validators.pattern(jsonFilterDefinition.pattern));
    }
    return validators;
  }

  private getFormControl(isMandatory: boolean, value: any): UntypedFormControl {
    return isMandatory
      ? new UntypedFormControl(value, [])
      : new UntypedFormControl(value);
  }
}
